function DefaultFallback() {
  return null;
}

export default DefaultFallback;
